import React from 'react'

const TermsAndCondition = () => {
  return (
    <div>
      
    </div>
  )
}

export default TermsAndCondition
